// removed by extract-text-webpack-plugin
module.exports = {"endring":"nrk-v17-static-endring"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/shared/Endring/index.css
// module id = 252
// module chunks = 0 1 4 5 8 9